// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"864b1e58","453":"5db14889","455":"3772c773","977":"d4384893"}[chunkId] + ".chunk.js";
};